import React from "react";
import Icon from "components/AppIcon";
import { useNavigation } from "components/ui/NavigationStateManager";

const ProductInfo = ({ product, currentStore }) => {
  if (!product) return null;
  const sessionId = sessionStorage.getItem("vto_session_id");
  const { getDisplayStoreName, getDisplayProductName } = useNavigation();

  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center space-x-2 mb-2">
          <span className="text-sm text-text-secondary">
            {getDisplayStoreName()}
          </span>
        </div>
        <h1 className="text-heading-2 text-text-primary mb-2">
          {getDisplayProductName(product)}
        </h1>
        <p className="text-text-secondary text-sm">
          {(() => {
            try {
              const categories = JSON.parse(product?.aCategoryIdJson || "[]");
              const uniqueNames = [
                ...new Set(categories.map((cat) => cat.sCategoryName)),
              ];
              return uniqueNames.join(", ");
            } catch {
              return "";
            }
          })()}
        </p>
      </div>

      <div className="space-y-2">
        <div className="flex items-center space-x-3">
          <span className="text-heading-3 text-text-primary">
            {product?.dPrice ? <>₹{product.dPrice.toFixed(2)}</> : null}
          </span>
        </div>
      </div>

      <div>
        <p className="text-text-secondary">{product?.description}</p>
      </div>

      <div className="pt-4">
        <button
          className="w-full btn-primary btn-lg flex items-center justify-center space-x-2"
          data-vto-button
          data-api-key={currentStore?.apiKey}
          data-session-id={sessionId}
          data-inventory-status="true"
          data-product-id={product?.sStoreVariantId || product?.sStoreProductId}
        >
          <Icon name="Eye" size={20} />
          <span>Try On</span>
        </button>
        <p className="text-xs text-text-secondary text-center mt-2">
          Virtual Try-On available for this product
        </p>
      </div>

      <div className="p-4 bg-primary-50 rounded-lg border border-primary-200">
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Eye" size={16} className="text-primary" />
          </div>
          <div className="flex-1">
            <h4 className="text-sm font-medium text-primary mb-1">VTO Demo</h4>
            <p className="text-xs text-primary-700">
              This product supports Virtual Try On . Click the Try On button to
              validate the VTO integration.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
